var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightThin = function SvgArrowRightThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "m14.672 2.635.088.09 6 7.015a1 1 0 0 1 .072 1.205l-.073.097-6 6.985a1 1 0 0 1-1.593-1.203l.075-.1 4.593-5.348H1.889a1 1 0 0 1-.117-1.994l.117-.006h15.927l-4.576-5.35a1 1 0 0 1 .02-1.323l.09-.087a1 1 0 0 1 1.322.02"
  })));
};
export default SvgArrowRightThin;